import React from 'react'
import classnames from 'classnames'

export default function Icon({ icon, className, ...other }) {
  return <i {...other} className={classnames('fa', `fa-${icon}`, className)} />
}


// WEBPACK FOOTER //
// client/components/util/Icon.js